import { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'

import { Collection } from '@shared-types/util'

export const CALENDAR_REFETCH_INTERVAL = 30000

/*
 * Continue to make requests to a paginated API until all results are obtained
 * NOTE: DO NOT USE THIS FOR LARGE COLLECTIONS
 */
export async function fetchAllPages<T, F extends { page?: number; limit?: number }>(
  baseFilters: F,
  fetchFunc: (filters: F) => Promise<Collection<T>>
): Promise<Collection<T>> {
  let results: T[] = []
  let response: Collection<T>

  const query = { ...baseFilters, page: 1, limit: 50 } as F

  do {
    response = await fetchFunc(query)
    results = [...results, ...response.results]

    if (response.next_page !== null) {
      query.page = response.next_page
    }
  } while (response.next_page !== null)

  return { results }
}

export const useClearAllQueries = () => {
  const queryClient = useQueryClient()
  return useCallback(async () => {
    queryClient.clear()
  }, [queryClient])
}
